import { SvgIcon, type SvgIconProps } from '@mui/material';
import { useId } from 'react';

type Props = SvgIconProps & { src: string };

/**
 * Renders an image asset (PNG/SVG) as a single-colour SvgIcon: the image's
 * alpha is used as a mask over the current fill, so parent colour rules
 * (e.g. the sidebar's selected state) recolour it like any MUI icon.
 */
export const MaskedSvgIcon: React.FC<Props> = ({ src, ...props }) => {
  const maskId = useId();

  return (
    <SvgIcon viewBox="0 0 20 20" {...props}>
      <mask height="20" id={maskId} style={{ maskType: 'alpha' }} width="20" x="0" y="0">
        <image height="20" href={src} width="20" />
      </mask>
      <rect height="20" mask={`url(#${maskId})`} width="20" />
    </SvgIcon>
  );
};
